module.exports = "/_next/static/images/uv-2-85549d9a44e586a481a0492b53e15644.png";